import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Growl } from "primereact/growl";
import servicioAsignacionValoresObjetos from "../servicio/ServicioObjetos";
import servicioHttp from "../servicio/ServicioHttp";
import { Message } from "primereact/message";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import ServicioArchivos from '../servicio/ServicioArchivos';
import servicioFormatos from '../servicio/ServicioFormatos';
import ServicioObjetos from '../servicio/ServicioObjetos';
import { Row } from 'primereact/row';
import { ColumnGroup } from 'primereact/columngroup';
import { Paginator } from 'primereact/paginator';
import servicioObjetos from "../servicio/ServicioObjetos";
import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR } from '../servicio/ServicioConstantes';

const MOVIMIENTOS = [
 
  { label: "Correctos", value: 0 },
  { label: "Erróneos", value: 1 }];

const TODOS = { label: "Todos", value: 0 };
const JOIN_PRINCIPAL = {
  "ttUsuario": "alias_ttUsuario",
  "tcEmpresa": "alias_tcEmpresa"
};
const PAGINACION_INICIAL = {
  registrosPorPagina: 10,
  join: null,
  restriccionesDinamicas: [
  ]
}
export class ConsultaMovimientosRegistroPatronal extends React.Component {
  constructor() {
    super();
    this.state = {
      resumenMovimientos: [],
      tcLoteSolicitudIdse: [],
      mostrarModalBitacora: false,
      errores: {},
      idsenube: 0,
      paginacion: PAGINACION_INICIAL,
      registrosPatronales: [],
      consulta: { movimiento: {} },
      movimientos: MOVIMIENTOS,
      lote: {},
      mostrarModalDescarga: false,
      mostrarCalendarios: true
    };
  }
  componentDidMount() {
    this.obtenerRegistrosPatronales();
  }

  obtenerRegistrosPatronales = () => {
    servicioHttp.consumirPostHttp('empresa/obtener_registro_patronal.json').then(response => {
      let registrosPatronales = [TODOS];
      var newArray = registrosPatronales.concat(response.data.lista);
      let { consulta } = this.state;
      consulta.registroPatronal = 0;
      this.setState({ registrosPatronales: newArray, consulta: consulta });
    }).catch(error => {

    });
  };

  asignarRestricciones = () => {
    let { consulta, paginacion, registrosPatronales } = this.state;
    paginacion.join = JOIN_PRINCIPAL;
    paginacion.restriccionesDinamicas = [];
    paginacion.ordenamientos =[];
    paginacion.ordenamientos.push({
      tipo:'desc',
      nombrePropiedad:'fecha'  
    });
    if (!servicioObjetos.esObjetoVacio(consulta.registroPatronal)) {
      if (consulta.registroPatronal !== 0) {
        paginacion.restriccionesDinamicas.push({
          tipoRestriccion: "eq",
          nombrePropiedad: "alias_tcEmpresa.id",
          valorPropiedad: consulta.registroPatronal
        });
      } else {
        let empresasUsuarioSesion = [];
        for (let index = 0; index < registrosPatronales.length; index++) {
          let elemento = registrosPatronales[index];
          if (elemento.value !== 0) {
            let valor=elemento.value;
            empresasUsuarioSesion.push(
              valor
            );
          }
        }
        paginacion.restriccionesDinamicas.push({
          tipoRestriccion: "in",
          nombrePropiedad: "alias_tcEmpresa.id",
          coleccionIn: empresasUsuarioSesion
        });
      }
    }
    if (!servicioObjetos.esObjetoVacio(consulta.fechaInicial) && !servicioObjetos.esObjetoVacio(consulta.fechaFinal)) {
      let fechaIncial = servicioFormatos.formatearFechaString(consulta.fechaInicial);
      let fechaFinal = servicioFormatos.formatearFechaString(consulta.fechaFinal).replace('00:00:00', '23:59:59');
      paginacion.restriccionesDinamicas.push({
        tipoRestriccion: "between",
        nombrePropiedad: "fecha",
        valorPropiedad: null,
        fechaIncialBetween: fechaIncial,
        fechaFinalBetween: fechaFinal
      });

    }
  }

  cambiaPagina = (event) => {
    let { paginacion } = this.state;
    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    this.setState({ idsenube: event.first });
    this.buscarPorFechas();
  }

  mostrarModal() {
    this.setState({ mostraModalTrabajador: true });
  }

  asignarValores = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
    if (event.target.id === "consulta.movimiento") {
      if (!servicioObjetos.esObjetoVacio(event.target.value))
        this.consultarMovimientos();
    }
  };

  consultarMovimientos = () => {
    let { consulta, lote } = this.state;
    let paginacionConsulta = {
      join: {
        "tcTrabajador": "alias_tcTrabajador",
        "ttLoteSolicitudIdse": "alias_ttLoteSolicitudIdse",
        "alias_ttLoteSolicitudIdse.tcEmpresa": "alias_tcEmpresa"
      }
    };
    paginacionConsulta.restriccionesDinamicas = [];
    paginacionConsulta.restriccionesDinamicas.push({
      tipoRestriccion: "eq",
      nombrePropiedad: "alias_ttLoteSolicitudIdse.id",
      valorPropiedad: lote.id,
      fechaIncialBetween: null,
      fechaFinalBetween: null
    });
    if (consulta.movimiento.value === 0) {
      //Correctos
      paginacionConsulta.restriccionesDinamicas.push({
        tipoRestriccion: "eq",
        nombrePropiedad: "estadoRespuesta",
        valorPropiedad: 0,
      });
      paginacionConsulta.restriccionesDinamicas.push({
        tipoRestriccion: "isNull",
        nombrePropiedad: "descripcionError",
       
      });

    } else {
      //Erroneos
      paginacionConsulta.restriccionesDinamicas.push({
        tipoRestriccion: "eq",
        nombrePropiedad: "estadoRespuesta",
        valorPropiedad: 1
      });
    }
    servicioHttp.consumirPostHttp('movimientos/consultar.json', paginacionConsulta).then(response => {
      this.setState({
        listaVistaMovimientos: response.data.objeto.datos
      });
    }).catch(error => {

    });
  }

  verBitacoraMovimientos = (objeto) => {
    let paginacion = {
      registrosPorPagina: 10,
      join: JOIN_PRINCIPAL,
      restriccionesDinamicas: [
        {
          tipoRestriccion: "eq",
          nombrePropiedad: "id",
          valorPropiedad: objeto.idLote
        }
      ]
    };

    let { consulta } = this.state;
    consulta.movimiento = {};
    servicioHttp.consumirPostHttp("solicitud/consultas.json", paginacion).then(responseConsultas => {
      servicioHttp.consumirPostHttp("movimientos/resumen_movimientos.json", { id: objeto.idLote }).then((responseResumenMovimientos) => {
        this.setState({
          lote: responseConsultas.data.objeto.datos[0],
          resumenMovimientos: responseResumenMovimientos.data.lista,
          mostrarModalBitacora: true,
          listaVistaMovimientos: []

        });
      }).catch((error) => { });
    }).catch(error => {

    });
  }

  llenardatos = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
  };

  descargarAfil(elemento) {
    ServicioArchivos.descargaArchivo("/solicitud/descargarAfil.json", { id: elemento.id });
  }

  descargarAcuse(elemento) {
    ServicioArchivos.descargaArchivo("/solicitud/descargarAcuse.json", { id: elemento.id });
  }

  reidsenubeVariables = () => {
    this.setState({ tcLote: {} });
  }

  buscarPorFechas = () => {
    let { consulta } = this.state;
    const errores = this.validarFechas(consulta);
    this.setState({ errores: errores });
    if (servicioObjetos.esObjetoVacio(errores)) {
      this.asignarRestricciones();
      let { paginacion } = this.state;
      servicioHttp.consumirPostHttp("solicitud/por_registro_patronal.json", paginacion).then((response) => {
        this.setState({ paginacion: response.data.objeto });
      }).catch(() => { });
    }
  }

  validarFechas = (objeto) => {
    const errores = {};
    if (ServicioObjetos.esObjetoVacio(objeto.fechaInicial))
      errores.fechaInicial = "Ingrese la Fecha Inicial";
    if (ServicioObjetos.esObjetoVacio(objeto.fechaFinal))
      errores.fechaFinal = "Ingrese la Fecha Final";
    return errores;
  };

  descargarMasiva = () => {
    let { paginacion } = this.state;
    ServicioArchivos.descargaArchivo('/solicitud/descargaMasiva.json', paginacion.datos);
  }
  descargarMasivaAfils = () => {
    let { paginacion } = this.state;
    ServicioArchivos.descargaArchivo('/solicitud/descargaMasivaAfil.json', paginacion.datos);
  }
  descargarReporteExcel = () => {
    let { tcLote, registroPatronal, usuario } = this.state;
    ServicioArchivos.descargaArchivo('/documentos/reporte_consulta_registro_patronal.json', { idRegistroPatronal: registroPatronal, fechaInicial: tcLote.fechaInicial.getTime(), fechaFinal: tcLote.fechaFinal.getTime(), idUsuario: usuario });
  }

  columnaFecha = (rowData, column) => {
    return <div>{servicioFormatos.formatearFecha(rowData.fecha)}</div>;
  }
  columnaFechaRespuesta = (rowData, column) => {
    return <div>{servicioFormatos.formatearFecha(rowData.fechaRespuesta)}</div>;
  }

  columnaDetalle = (rowData, column) => {
    return (
      <div style={{ width: '250px' }}>
        <div className="p-grid">
          <div className="p-col-12 p-md-6"><Button type="button" icon="pi-md-remove-red-eye" label="Ver Detalle" onClick={(e) => this.verBitacoraMovimientos(rowData)}></Button></div>
          <div className="p-col-12 p-md-6"><Button type="button" icon="pi-md-insert-drive-file" label="Recibo" onClick={(e) => this.verModalDescarga(rowData)}></Button></div>
        </div>
      </div>
    );
  }

  columnaFechaTransmision = (rowData, column) => {
    return servicioFormatos.formatearFecha(rowData.fechaTransicion);
  }

  cambioTipoMovimiento = (event) => {
    let paginacion = {

    };
    servicioHttp.consumirPostHttp("movimientos/consultar_detalle_movimientos.json", paginacion).then((response) => {
      this.setState({ paginacionMovimientos: response.data.objeto, verModalHistoricoDeMovimientosLote: true });

    }).catch((error) => {
      this.growl.show({
        severity: "error", summary: "", detail: "Se generó un error no esperado, por favor inténtelo de nuevo",
      });
    });
  }

  columnaNombreEmpleado = (rowData, column) => {
    return <div>{rowData.nombre + " " + rowData.primerApellido + " " + rowData.segundoApellido}</div>;
  }

  columnaSalarioDiario = (rowData, column) => {
    return servicioFormatos.formatoSalarioDiarioIntegradoString(rowData.salarioDiarioIntegrado);
  }
  columnafechaMovimiento = (rowData, column) => {
    return servicioFormatos.formatearFechaStringIdse(rowData.fechaMovimiento);
  }

  columnaConsultaError = (rowData, column) => {
    let descripcionError = servicioObjetos.esObjetoVacio(rowData.descripcionError) ? "" : rowData.descripcionError;
    let descripcionErrorAfil = servicioObjetos.esObjetoVacio(rowData.descripcionErrorAfil) ? "" : rowData.descripcionErrorAfil;
    return descripcionError + descripcionErrorAfil;
  }

  exportarMovimientosExcel = () => {
    let { consulta, lote } = this.state;
    let url = "";
    let paginacionConsulta = {
      join: {
        "tcTrabajador": "alias_tcTrabajador",
        "ttLoteSolicitudIdse": "alias_ttLoteSolicitudIdse",
        "alias_ttLoteSolicitudIdse.tcEmpresa": "alias_tcEmpresa"
      }
    };
    paginacionConsulta.restriccionesDinamicas = [];
    paginacionConsulta.restriccionesDinamicas.push({
      tipoRestriccion: "eq",
      nombrePropiedad: "alias_ttLoteSolicitudIdse.id",
      valorPropiedad: lote.id,
      fechaIncialBetween: null,
      fechaFinalBetween: null
    });
    if (consulta.movimiento.value === 0) {
      //Correctos
      url = "movimientos/descargar_excel_correctos.json";
      paginacionConsulta.restriccionesDinamicas.push({
        tipoRestriccion: "eq",
        nombrePropiedad: "estadoRespuesta",
        valorPropiedad: 0,
      });
    } else {
      //Erroneos
      url = "movimientos/descargar_excel_erroneos.json";
      paginacionConsulta.restriccionesDinamicas.push({
        tipoRestriccion: "eq",
        nombrePropiedad: "estadoRespuesta",
        valorPropiedad: 1
      });
    }
    ServicioArchivos.descargaArchivo(url, paginacionConsulta, this);
  }

  cerrarModalDetalle = () => {
    this.setState({ mostrarModalBitacora: false });
  }

  cerrarModalDescarga = () => {
    this.setState({ mostrarModalDescarga: false });
  }

  verModalDescarga = (objeto) => {    
    this.setState({ objetoAfil: objeto });
    this.setState({ mostrarModalDescarga: true });
  }

  descargaAfilGlobal = () => {
    let { objetoAfil } = this.state;
    ServicioArchivos.descargaArchivo('documentos/descarga_acuse.json', { archivoAcuseRecibo: objetoAfil.archivoAfil }, this);
  }

  descargaAfilInvidual = () => {
    let { objetoAfil } = this.state;    
    ServicioArchivos.descargaArchivo('documentos/afil_individual_zip.json', { id: objetoAfil.idLote });
  }

  reiniciarFrmBusqueda = () => {
    let consulta = {};
    this.setState({
      mostrarCalendarios: false,
      consulta: consulta,
      paginacion: PAGINACION_INICIAL
    });
    setTimeout(() => {
      this.setState({ mostrarCalendarios: true });
    }, 50);
    this.obtenerRegistrosPatronales();
  }

  columnaEstado = (rowData, column) => {
    return servicioFormatos.filtroEstadoLote(rowData.estado);
  }

  colunmaExtemporaneo = (rowData, column) => {
    return servicioFormatos.filtroExtemporaneo(rowData.extemporaneo);
  }

  columnaTipoMovimiento = (rowData, column) => {
    return servicioFormatos.formatoTipoMovimiento(rowData.tipoMovimiento);
  }

  columnaTipoTrabajador = (rowData, column)=>{
    return servicioFormatos.formatoTipoTrabajador(rowData.tipoTrabajador);
  }

  columnaJornadaReducida = (rowData, column) => {
    return servicioFormatos.formatoTipoJornada(rowData.jornadaReducida);
  }
  columnaTipoSalario = (rowData, column) => {
    return servicioFormatos.formatoTipoSalario(rowData.tipoSalario);
  }

  exportarTodosMovimientosExcel = () => {
    this.asignarRestricciones();
    let { paginacion } = this.state;        
    ServicioArchivos.descargaArchivo("solicitud/exportar_excel_detallado.json", paginacion, this);
  }

  render() {
    let { paginacion, errores, idsenube, resumenMovimientos, registrosPatronales, consulta,
      mostrarModalBitacora, movimientos, listaVistaMovimientos, lote, mostrarModalDescarga, mostrarCalendarios } = this.state;

    let encabezadosTabla = <ColumnGroup>
      <Row>
        <Column header="Lote" rowSpan={3} />
        <Column header="Estado" rowSpan={3} />
        <Column header="Registro Patronal" rowSpan={3} />
        <Column header="Usuario" rowSpan={3} />
        <Column header="Fecha Transmisión" rowSpan={3} />
        <Column header="Fecha Respuesta" rowSpan={3} />
        <Column header="Movimientos" rowSpan={3} />
        <Column header="Errores" rowSpan={3} />
      </Row>
      <Row>
        <Column header="Bajas" colSpan={3} />
        <Column header="Modificaciones" colSpan={3} />
        <Column header="Reingresos" colSpan={3} />
        <Column header="Detalle" rowSpan={3} />
      </Row>
      <Row>
        <Column header="Movimientos" />
        <Column header="Correcto" />
        <Column header="Error" />
        <Column header="Movimientos" />
        <Column header="Correcto" />
        <Column header="Error" />
        <Column header="Movimientos" />
        <Column header="Correcto" />
        <Column header="Error" />
      </Row>
    </ColumnGroup>;


    let encabezadosTablaDetalle = <ColumnGroup>
      <Row>
        <Column header={<b>Bajas</b>} colSpan={3} />
        <Column header={<b>Modificaciones</b>} colSpan={3} />
        <Column header={<b>Reingresos</b>} colSpan={3} />
      </Row>
      <Row>
        <Column header="Movimientos" />
        <Column header="Correcto" />
        <Column header="Error" />
        <Column header="Movimientos" />
        <Column header="Correcto" />
        <Column header="Error" />
        <Column header="Movimientos" />
        <Column header="Correcto" />
        <Column header="Error" />
      </Row>
    </ColumnGroup>;

    let pieTablaExportarCorrectos = <div className="p-fluid p-grid">
      <div className="p-col-12 p-md-2">
        {!servicioObjetos.esObjetoVacio(listaVistaMovimientos) ? <Button className="p-button-secondary" type="button" onClick={this.exportarMovimientosExcel} name="Excel" label="Excel" icon="pi-md-import-export" tooltip="Excel"></Button> : null}
      </div>
    </div>;

    let tablaCorrectos = <DataTable value={listaVistaMovimientos} responsive={true}
      header="Resultados" autoLayout={true} resizableColumns={true} footer={pieTablaExportarCorrectos}>
      <Column body={this.columnaTipoMovimiento} header="Tipo de movimiento" />
      <Column body={this.colunmaExtemporaneo} header="Extemporaneo" />
      <Column field="numeroSeguridadSocial" header="NSS" />
      <Column body={this.columnaNombreEmpleado} header="Nombre del Empleado" />
      <Column body={this.columnafechaMovimiento} header="Fecha del Movimiento" />
      <Column body={this.columnaTipoTrabajador} header="Tipo de Trabajador" />
      <Column body={this.columnaJornadaReducida} header="Tipo de Jornada" />
      <Column body={this.columnaTipoSalario} header="Tipo de Salario" />
      <Column body={this.columnaSalarioDiario} header="SDI" />
      <Column field="umf" header="UMF" />
    </DataTable>;

    let tablaErrores = <DataTable value={listaVistaMovimientos} responsive={true}
      header="Resultados" autoLayout={true} resizableColumns={true} footer={pieTablaExportarCorrectos}>
      <Column body={this.columnaTipoMovimiento} header="Tipo de movimiento" />
      <Column field="numeroSeguridadSocial" header="NSS" />
      <Column body={this.columnaNombreEmpleado} header="Nombre del Empleado" />
      <Column body={this.columnaConsultaError} header="Error" />
    </DataTable>;


    let pieDialogoDetalle = (
      <div className="ui-dialog-buttonpane p-clearfix">
        <Button label="Cerrar" icon="pi-md-close" onClick={this.cerrarModalDetalle} className="p-button-danger" />
      </div>
    );
    let pieDialogoDescarga = (
      <div className="ui-dialog-buttonpane p-clearfix">
        <Button label="Cerrar" icon="pi-md-close" onClick={this.cerrarModalDescarga} className="p-button-danger" />
      </div>
    );

    let calendardioInicial = <div>
      <Calendar dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} id="consulta.fechaInicial" name="consulta.fechaInicial" value={consulta.fechaInicial} onChange={(e) => { this.asignarValores(e, false) }} className={errores.fechaInicial ? 'p-error' : ''} />
      {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
    </div>;

    let calendardioFinal = <div>
      <Calendar dateFormat={FORMATO_FECHA_CALENDAR} locale={CALENDARIO_ES_MX} id="consulta.fechaFinal" name="consulta.fechaFinal" value={consulta.fechaFinal || ''} onChange={(e) => { this.asignarValores(e, false) }} className={errores.fechaFinal ? 'p-error' : ''} />
      {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
    </div>;

let pieTablaExportarTodos = <div className="p-fluid p-grid">
<div className="p-col-12 p-md-2">
  {!servicioObjetos.esObjetoVacio(paginacion.datos) ? <Button className="p-button-secondary" type="button" onClick={this.exportarTodosMovimientosExcel} name="Excel" label="Excel" icon="pi-md-import-export" tooltip="Excel"></Button> : null}
</div>
</div>;
    return (

      <div className="p-fluid">
        <Growl ref={(el) => this.growl = el} />
        <div className="p-grid">
          <div className="p-col-12">
            <div className="card card-w-title">
              <h1>Consultas por registro patronal</h1>
              <div className="p-fluid p-grid">
                <div className="p-col-12 p-md-2">
                  <label>* Registro Patronal:</label>
                </div>
                <div className="p-col-12 p-md-4">
                  <Dropdown filter={true} filterPlaceholder="Filtra por RP o Nombre corto" filterBy="value,label" showClear={true}
                  appendTo={document.body} id="consulta.registroPatronal" name="consulta.registroPatronal" 
                  optionLabel="label" optionValue="value"
                  options={registrosPatronales} value={consulta.registroPatronal} 
                  onChange={(e) => this.asignarValores(e, false)}
                    autoWidth={false} style={{ width: "100%" }} className={errores.registroPatronal ? "p-error" : ""} />
                  {errores.registroPatronal ? (<div><br /> <Message severity="error" text={errores.registroPatronal} />{" "}</div>) : null}
                </div>
                <div className="p-col-12 p-md-6"></div>
                <div className="p-col-12 p-md-2">* Fechas de Transmisión:</div>
                <div className="p-col-12 p-md-1">Entre:</div>
                <div className="p-col-12 p-md-4">
                  {mostrarCalendarios ? calendardioInicial : null}
                </div>
                <div className="p-col-12 p-md-1">
                  y:
                </div>
                <div className="p-col-12 p-md-4">
                  {mostrarCalendarios ? calendardioFinal : null}
                </div>
              </div>
              <div className="p-grid">
                <div className="p-col-12 p-md-2"><Button label="Limpiar" icon="pi-md-refresh" onClick={this.reiniciarFrmBusqueda} /></div>
                <div className="p-col-12 p-md-2"><Button label="Buscar" icon="pi-md-search" onClick={this.buscarPorFechas} /></div>
              </div>
            </div>
          </div>
        </div>
        <div>          
          <div className="card card-w-title">
            <DataTable value={paginacion.datos} editable={true} selectionMode="single" responsive={true}
              header="Bitacora de Lotes" headerColumnGroup={encabezadosTabla} autoLayout={true} resizableColumns={true} footer={pieTablaExportarTodos}>
              <Column field="lote" />
              <Column body={this.columnaEstado} />
              <Column field="registroPatronal" />
              <Column field="usuario" />
              <Column body={this.columnaFechaTransmision} />
              <Column body={this.columnaFechaRespuesta} />
              <Column field="movimientos" />
              <Column field="errores" />
              <Column field="bMovimientos" />
              <Column field="bCorrectos" />
              <Column field="bErrores" />
              <Column field="mMovimientos" />
              <Column field="mCorrectos" />
              <Column field="mErrores" />
              <Column field="rMovimientos" />
              <Column field="rCorrectos" />
              <Column field="rErrores" />
              <Column body={this.columnaDetalle} />
            </DataTable>
            <Paginator first={idsenube} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} />
          </div>
        </div>
        <Dialog appendTo={document.body} header="Respuesta IMSS" style={{width: '90%',height:'90%'}} modal={true} visible={mostrarModalBitacora} onHide={this.cerrarModalDetalle} footer={pieDialogoDetalle} >
          <div className="card card-w-title">
            <div className="p-grid">
              <div className="p-col-12 p-md-2"><b>Lote:</b></div>
              <div className="p-col-12 p-md-10">{lote.loteIdImss}</div>
              <div className="p-col-12 p-md-2"><b>Registro Patronal:</b></div>
              <div className="p-col-12 p-md-10">{lote.registroPatronal}</div>
              <div className="p-col-12 p-md-2"><b>Nombre:</b></div>
              <div className="p-col-12 p-md-10">{lote.razonSocial}</div>
              <div className="p-col-12 p-md-2"><b>Fecha de Transacción</b></div>
              <div className="p-col-12 p-md-10">{servicioFormatos.formatearFecha(lote.fecha)}</div>
              <div className="p-col-12 p-md-2"><b>Fecha de Respuesta</b></div>
              <div className="p-col-12 p-md-10">{servicioFormatos.formatearFecha(lote.fechaRespuesta)}</div>
            </div>
            <h1>AFIL IDSE 03 Respuesta al patrón</h1>
          </div>
          <div className="card">
            <DataTable value={resumenMovimientos} responsive={true}
              header="Resumen general" headerColumnGroup={encabezadosTablaDetalle} autoLayout={true} resizableColumns={true}>
              <Column field="totalBajas" />
              <Column field="correctosBaja" />
              <Column field="erroresBaja" />
              <Column field="totalModificaciones" />
              <Column field="correctosModificaciones" />
              <Column field="erroresModificaciones" />
              <Column field="totalReingresos" />
              <Column field="correctosReingresos" />
              <Column field="erroresReingresos" />
            </DataTable>
          </div>
          <div className="card">
            <div className="p-grid">
              <div className="p-col-12 p-md-2"><b>Vista de Movimientos:</b></div>
              <div className="p-col-12 p-md-4"><Dropdown appendTo={document.body} id="consulta.movimiento" name="consulta.movimiento" optionLabel="label" placeholder="Seleccionar" options={movimientos} value={consulta.movimiento} onChange={(e) => this.asignarValores(e, false)}
                autoWidth={false} style={{ width: "100%" }} className={errores.movimiento ? "p-error" : ""} /></div>
            </div>
          </div>
          <div className="card">
            {servicioObjetos.esObjetoVacio(consulta.movimiento) ? null : (consulta.movimiento.value === 0 ?
              tablaCorrectos : tablaErrores)}
          </div>
        </Dialog>

        <Dialog header="Descarga" modal={true} visible={mostrarModalDescarga} onHide={this.cerrarModalDescarga} footer={pieDialogoDescarga}>
          <div className="card">
            <div className="p-grid">
              <div className="p-col-12 p-md-6"><Button label="CONSTANCIA DE PRESENTACIÓN DE MOVIMIENTO (AFIL)" icon="pi-md-file-download" onClick={this.descargaAfilGlobal} /></div>
              <div className="p-col-12 p-md-6"><Button label="CONSTANCIAS MOVIMIENTOS INDIVIDUALES (AFIL)" icon="pi-md-file-download" onClick={this.descargaAfilInvidual} /></div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}
